__turbopack_context__.v({
  "wrapper": "LegalTextStack-module__LaZ9Iq__wrapper",
});
